import axios from 'axios';
import * as React from 'react';
import { requestDisconnectGoogle } from '../asyncHelpers/googleAuthService';
import { RequestStatus } from '../sic-lib/enums/RequestStatus';
import { useAppDispatch } from '../store/hooks';
import { createToast } from '../store/notify';
import { createErrorToast } from '../utils/notifyHelpers';

/**
 * useAsyncCreateUser
 *
 * @description
 * Wrapper function for managing state and request cancellation for
 * requestCreateUser HTTP request.
 */
export default function useAsyncDisconnectGoogleAuth() {
    const dispatch = useAppDispatch();
    const request_token = axios.CancelToken.source();

    React.useEffect(() => {
        return () => {
            request_token.cancel();
        };
    }, []);

    const [requestStatus, setRequestStatus] = React.useState<RequestStatus>(RequestStatus.none);

    const asyncDisconnectGoogleAuth = async (): Promise<void> => {
        try {
            setRequestStatus(RequestStatus.active);

            const { data } = await requestDisconnectGoogle(request_token.token);

            setRequestStatus(RequestStatus.success);
        } catch (e: any) {
            if (!axios.isCancel(e)) {
                //in case user already exists
                if (axios.isAxiosError(e)) {
                    if (e.response?.status == 400 || e.response?.status == 404) {
                        /* Notify user of failed http request */
                        const toastData = createErrorToast(e.response.data);

                        dispatch(createToast({ toastData }));
                    }
                }

                /* Update state */
                setRequestStatus(RequestStatus.error);
            }
        }
    };

    return {
        requestStatus,
        asyncDisconnectGoogleAuth,
    };
}
